import { set } from 'lodash';
import { AnyStoreState } from '../reducers';

/**
 *  Creates a function to update a single field in a reducer
 */
export const createSimpleHandler = <T>(fieldName: string) => (
  state: AnyStoreState,
  { payload }: { payload: any }
): T => set<T>({ ...state }, fieldName, payload);
